import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { MasterService } from '../../../base-classes/master-service';
import { Client} from '../viewmodels/client-viewmodel';

@Injectable({
    providedIn: 'root'
})
export class ClientService extends MasterService<Client> {
    constructor(http: HttpClient) {
        const baseUrl = `${environment.apiUrl}/clients`;
        super(http, baseUrl);
    }

    // Get all Clients
    public getClientsAll() {
        return this.http.get<any[]>(`${environment.apiUrl}/clients`);
    }

    // Get clients accessible by current user (based on token)
    public getMyClients() {
        return this.http.get<any[]>(`${environment.apiUrl}/clients/user-clients`);
    }

    public canDeleteClient(id: any): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}/clients/${id}/find-users`);
    }

    public deleteClient(id: any, force: boolean = false): Observable<any> {
        const url = force 
            ? `${environment.apiUrl}/clients/${id}?force=true`
            : `${environment.apiUrl}/clients/${id}`;
        return this.http.delete<any>(url);
    }

    // Get all Tenants
    public getTenantsAll() {
        return this.http.get<any[]>(`${environment.apiUrl}/tenants`);
    }

    override save(item: Client): Observable<Client> {
        if (item.id) {
            return this.updateItem(item);
        } else {
            return this.createItem(item);
        }
    }

    private createItem(item: Partial<Client>): Observable<Client> {
        return this.http.post<Client>(`${this.baseUrl}`, item);
    }

    private updateItem(item: Partial<Client>): Observable<Client> {
        return this.http.post<Client>(`${this.baseUrl}`, item);
    }

    public getClientTenants(clientId: string): Observable<any[]> {
        return this.http.get<any[]>(`${environment.apiUrl}/client-tenants/client/${clientId}`);
    }

    public saveClientTenants(tenants: any[]): Observable<any> {
        return this.http.post<any>(`${environment.apiUrl}/client-tenants`, tenants);
    }

    public getAuthTypes(): Observable<any[]> {
        return this.http.post<any[]>(`${environment.apiUrl}/reference-values/by-code-keys`, { codeKeys: ['AUTH_TYPE'] });
    }
}